import { useMutation } from '@tanstack/react-query';
import { queryClient } from '~/lib/react-query';
import { hideLoader, showLoader } from '~/common';

interface EnrollmentData {
  training_id: string;
  training_type: string;
  external_user_ids?: string[];
  emails: string[];
  due_at?: string | null;
}

interface UseEnrollmentProps {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export const useEnrollment = ({ onSuccess, onError }: UseEnrollmentProps = {}) => {
  const enrollUsers = async (enrollmentData: EnrollmentData) => {
    showLoader();
    const response = await fetch('/academies/api/enrollments', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
      },
      body: JSON.stringify(enrollmentData),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(`Enrollment failed: ${response.status} ${response.statusText}`, { cause: errorData });
    }

    return response.json();
  };

  return useMutation({
    mutationFn: enrollUsers,
    onSuccess: () => {
      queryClient.invalidateQueries(['team-lead-contacts']);
      queryClient.invalidateQueries(['assignments']);
      onSuccess?.();
    },
    onError: (error: Error) => {
      onError?.(error);
    },
    onSettled() {
      hideLoader();
    },
  });
};
